export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-xs uppercase tracking-wider text-[#C77A5A] font-semibold mb-4">WHO WE ARE</p>
          <h2 className="text-4xl lg:text-5xl font-serif text-[#0F0F0F] leading-tight">
            Your Caribbean Partner in <span className="bg-gradient-to-r from-[#9B5E6B] to-[#F2A35E] bg-clip-text text-transparent">Digital Success</span>
          </h2>
        </div>

        {/* Agency History Section */}
        <div className="mb-20 bg-gradient-to-br from-[#F6C1A1]/20 to-[#F2A35E]/10 rounded-3xl p-12 border border-[#F6C1A1]/40">
          <div className="flex items-start gap-6 mb-6">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#9B5E6B] flex-shrink-0">
              <i className="ri-book-open-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-[#0F0F0F] mb-2">Our Story</h3>
              <p className="text-sm uppercase tracking-wider text-[#C77A5A] font-semibold">FOUNDED IN THE HEART OF THE CARIBBEAN</p>
            </div>
          </div>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              Have you ever worked with an agency that promised you everything but failed to meet your expectations? Or even worse, ended up damaging your account? That’s how this journey began. A few years ago, I decided to become a model and trusted an agency that came to me with big promises—but none of them were fulfilled, and my account suffered as a result.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Because of that experience, my partner and I decided to study, analyze, and truly understand how to grow an account strategically and sustainably, starting with my own. Once we achieved real results, we realized that many other girls—especially Latina creators—were going through the exact same situation I had faced, without real guidance or support.
            </p>
            <p className="text-gray-700 leading-relaxed">
              That’s how Venezia Agency was born, from a vision to blend Caribbean warmth with world-class digital expertise. What started as a small collective supporting local creators has grown into a full-service agency managing top-tier talent across the globe. Today, we’re proud to have helped hundreds of creators achieve financial freedom while preserving their authenticity and privacy, building genuine relationships and long-term success.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-[#F6C1A1]/30">
            <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-[#9B5E6B] mb-6">
              <i className="ri-user-star-line text-3xl text-[#9B5E6B]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#0F0F0F] mb-4">Personalized Management</h3>
            <p className="text-gray-600 leading-relaxed">
              Every creator is unique. We craft custom strategies tailored to your brand, audience, and goals for maximum impact and growth.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-[#F6C1A1]/30">
            <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-[#9B5E6B] mb-6">
              <i className="ri-line-chart-line text-3xl text-[#9B5E6B]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#0F0F0F] mb-4">Data-Driven Results</h3>
            <p className="text-gray-600 leading-relaxed">
              Our analytics-first approach ensures every decision is backed by insights, optimizing your content and engagement for proven results.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-[#F6C1A1]/30">
            <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-[#9B5E6B] mb-6">
              <i className="ri-shield-check-line text-3xl text-[#9B5E6B]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#0F0F0F] mb-4">Complete Privacy</h3>
            <p className="text-gray-600 leading-relaxed">
              Your security is paramount. We maintain strict confidentiality and implement industry-leading protection for your content and data.
            </p>
          </div>
        </div>

        <div className="relative rounded-3xl overflow-hidden h-96">
          <img 
            src="https://public.readdy.ai/ai/img_res/959274af73c387bc24e71c8e6bab98a8.jpg" 
            alt="Caribbean Beach Sunset" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#7B4A5A]/80 via-[#7B4A5A]/40 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-12">
            <div className="max-w-3xl">
              <i className="ri-double-quotes-l text-5xl text-white/40 mb-4"></i>
              <p className="text-2xl lg:text-3xl font-serif text-white leading-relaxed italic">
                "Venezia Agency transformed my OnlyFans from a side hustle into a six-figure business. Their Caribbean warmth combined with professional expertise is unmatched."
              </p>
              <p className="text-white/90 mt-6 font-medium">— Sofia Martinez, Top 0.1% Creator</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
